import { Box, Drawer, Typography } from '@mui/material';
import { useLayoutEffect, useState } from 'react';
import { ContentTile, Maybe, NavigationGroup, NavigationLink } from '@/graphql/__generated/sdk';
import { FeaturedLinkRender } from './GroupNavItem';
import { getSubNavColumnStyles, getSubNavColumnTitleLinkStyles, getSubNavLinkStyles, subNavContentTilesStyles, subNavMobileBackButtonWrapperStyles, subNavMobileDropMenuStyles, subNavMobileGridStyles } from './GroupNavItem.styles';
import GroupNavMobileLink from './GroupNavMobileLink';
import HeaderContentTile from './HeaderContentTile';
import TAGButton from '../../TAGButton';
import TAGSvgIcon from '@shared-components/components/TAGSvgIcon';
interface IGroupNavMobileMenu {
  open: boolean;
  toolbarRef?: React.RefObject<HTMLDivElement>;
  label?: string;
  onClose: (event: React.MouseEvent<HTMLElement>) => void;
  contentTiles?: Array<Maybe<ContentTile>>;
  children?: React.ReactNode;
  featuredLink?: Maybe<NavigationLink>;
  subNavGroups?: Array<Maybe<NavigationGroup>>;
}
export const SubNavColumnRender = ({
  subNavGroup
}: {
  subNavGroup: any;
}) => {
  // Each group represents a list of links under a super-group
  return subNavGroup.map((subgroup, groupIndex) => subgroup && <Box data-testid={`nav_grouping_${subgroup.groupLink?.sys.id ?? groupIndex}`} key={subgroup.groupLink?.sys.id ?? groupIndex} sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem'
  }}>
					{subgroup.groupLink?.linkText && <GroupNavMobileLink {...subgroup.groupLink} isInternal={Boolean(subgroup.groupLink.isInternal)} dataTestId={`link_navlink_nav_group_title_${subgroup.groupLink.sys.id}`} linkSx={getSubNavColumnTitleLinkStyles()} textVariant="bodyMediumBold" />}
					{subgroup.linksCollection?.items?.map(navItem => navItem && <GroupNavMobileLink key={navItem.sys.id} {...navItem} isInternal={Boolean(navItem.isInternal)} dataTestId={`link_navlink_nav_group_${groupIndex}_item_${navItem.sys.id}`} linkSx={getSubNavLinkStyles()} textVariant="bodyMediumBook" />)}
				</Box>);
};
export default function GroupNavMobileMenu({
  open,
  toolbarRef,
  label,
  onClose,
  contentTiles,
  featuredLink,
  subNavGroups
}: Readonly<IGroupNavMobileMenu>) {
  const [top, setTop] = useState(0);
  useLayoutEffect(() => {
    if (open) {
      setTop(toolbarRef?.current?.getBoundingClientRect().bottom ?? 0);
    }
  }, [open, toolbarRef]);
  return <Drawer anchor="right" open={open} onClose={onClose} sx={subNavMobileDropMenuStyles} PaperProps={{
    style: {
      top,
      height: `calc(100% - ${top}px)`
    }
  }} ModalProps={{
    BackdropProps: {
      invisible: true
    }
  }} data-sentry-element="Drawer" data-sentry-component="GroupNavMobileMenu" data-sentry-source-file="GroupNavMobileMenu.tsx">
			<Box data-testid="nav_group_grid" sx={subNavMobileGridStyles} data-sentry-element="Box" data-sentry-source-file="GroupNavMobileMenu.tsx">
				<TAGButton component="button" type="button" dataTestId="nav_group_back_button" onClick={onClose} sx={subNavMobileBackButtonWrapperStyles} data-sentry-element="TAGButton" data-sentry-source-file="GroupNavMobileMenu.tsx">
					<Typography component="span" color="tertiary.main" sx={{
          display: 'inline-flex',
          alignItems: 'center'
        }} data-sentry-element="Typography" data-sentry-source-file="GroupNavMobileMenu.tsx">
						<TAGSvgIcon icon="ChevronLeftFunc" size={24} data-sentry-element="TAGSvgIcon" data-sentry-source-file="GroupNavMobileMenu.tsx" />
					</Typography>
					<Typography component="span" color={'text.interactive'} variant="bodySmallSemiBold" sx={{
          textTransform: 'uppercase'
        }} data-sentry-element="Typography" data-sentry-source-file="GroupNavMobileMenu.tsx">
						{label}
					</Typography>
				</TAGButton>
				{featuredLink && <FeaturedLinkRender featuredLink={featuredLink} isMobile={true} />}

				{subNavGroups && <Box sx={getSubNavColumnStyles()}>
						<SubNavColumnRender subNavGroup={subNavGroups} />
					</Box>}
				{Boolean(contentTiles?.length) && <Box data-testid="nav_group_content_tiles" sx={subNavContentTilesStyles}>
						{contentTiles?.map(tile => tile && <HeaderContentTile key={tile.sys.id} tile={tile} />)}
					</Box>}
			</Box>
		</Drawer>;
}